export const colorPalette = [
  "#EEEEEE", // Gris
  "#DCEDC8", // Verde
  "#FFECB3", // Amarillo
  "#FFCDD2", // Rojo
  "#B3E5FC", // Azul
  "#FFE4FE", // Morado
]
